import request from '@/utils/request'

const apis = {
  WECHAT_CONFIG: '/remoteapi/verifyConfig4WeChat'
}

export default {

  // 信息列表
  verifyConfig4WeChat(data) {
    let dt = data || {};
    return request.post(apis.WECHAT_CONFIG, dt.params, {
      headers: dt.headers || {}
    });
  }
}




// WEBPACK FOOTER //
// ./src/api/wechat.js